<template>
    <div class="container">
            <div class="row">
                <div class="col text-center">
                    <h1>Gainage progressif</h1>
                    <p>par Laurent ROMEDENNE</p>
                </div>
            </div>

            <div class="row">
                <div class="d-block d-sm-none col-md">
                    <img src="src/assets/images/gp-logo.png"
                         class="img-fluid responsive rounded mx-auto d-block"
                         style="width: 250px"/>
                </div>
                <div class="d-none d-sm-block col-md">
                    <img src="src/assets/images/gp-logo.png" class="img-fluid responsive rounded mx-auto d-block" />
                </div>
            </div>

        <form >
            <div class="row">
                <div class="col-xs col-md-8 offset-md-2 form-group">
                    <label for="username">Saisissez votre pseudo</label>
                    <input type="text" class="form-control" id="username" v-model="username">
                </div>
            </div>

            <div class="row">
                <div class="col-xs col-md-8 offset-md-2 form-group">
                    <label for="password">Saisissez votre code d'accès</label>
                    <input type="password" class="form-control" id="password" v-model="password">
                    <b-alert variant="danger" fade dismissible v-model="wrongAccessCode">
                        <strong>Code d'accès erroné !</strong><br/>
                        Veuillez vérifier votre saisie. Pour obtenir un code d'accès, contactez <a href="mailto:contact@laurentromedenne.com">Laurent ROMEDENNE</a>
                    </b-alert>
                </div>
            </div>
            <div class="row">
                <div class="d-none d-sm-block col-xs col-md-8 offset-md-2">
                    <button class="btn btn-rectangle-sm-a btn-block btn-primary block-center" v-on:click.prevent="loginCheck(false)">Démarrer ma séance de test</button>
                    <button class="btn btn-rectangle-sm-b btn-block btn-outline-primary block-center" v-on:click.prevent="loginCheck(true)">Votre toute première séance</button>
                </div>
                <div class="d-block d-sm-none col-xs col-md-8 offset-md-2">
                    <button class="btn btn-rectangle-xs-a btn-block btn-primary block-center" v-on:click.prevent="loginCheck(false)">Démarrer ma séance de test</button>
                    <button class="btn btn-rectangle-xs-b btn-block btn-outline-primary block-center" v-on:click.prevent="loginCheck(true)">Votre toute première séance</button>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    export default {
        data: function () {
            return {
                username: '',
                password: '',
                userParams: {},

                wrongAccessCode: false,
            }
        },
        mounted() {
            if (localStorage.getItem('userParams')) {
                try {
                    this.userParams = JSON.parse(localStorage.getItem('userParams'));
                    console.log(this.userParams);
                    if(this.userParams.hasOwnProperty('localStorage')
                        && this.userParams.localStorage == true) {
                        //todo: Vérification de l'expiry
                        if (this.userParams.hasOwnProperty('username')) {
                            this.username = this.userParams.username;
                        }
                        if (this.userParams.hasOwnProperty('password')) {
                            this.password = this.userParams.password;
                        }
                    }

                } catch(e) {
                    localStorage.removeItem('userParams');
                }
            } else {
                //Traitement si le localStorage ne contient pas la donnée
            }
        },
        methods: {
            loginCheck: function (isFirstTraining) {
                //logique de contrôle
                if(this.$store.getters.debug
                    || (this.password == this.$store.getters.accessCode
                    || (this.password == this.$store.getters.lsCode))) {
                    this.wrongAccessCode = false;
                    // this.$emit('userLogged', this.username);
                    /* début future fonctionnalité de mémoire */
                    if(this.password == this.$store.getters.lsCode) {
                        //Le mot de passe est bon: on autorise le local storage
                        this.userParams.localStorage = true;
                        //On met a jour le user et le mot de passe
                        this.userParams.username = this.username;
                        this.userParams.password = this.password;
                        //todo : Mise à jour expiry
                        //On charge les usersParams dans le store

                    }
                    this.$store.dispatch('updateUserParams', this.userParams);
                    /* début future fonctionnalité de mémoire */
                    this.$store.dispatch('updateUsername', this.username);
                    this.$store.dispatch('updateIsFirstTraining', isFirstTraining);

                    if(this.$store.getters.userParams.disclaimerAccepted == true) {
                        this.$store.dispatch('grantAccess');
                        this.$router.push({path: '/training'});
                    } else {
                        this.$router.push({path: '/disclaimer'});
                    }

                } else {
                    this.wrongAccessCode = true;
                }
            },

        }
    }
</script>





// WEBPACK FOOTER //
// src/components/Home.vue